<template>
  <div class="w-full h-[57px] bg-[#334155] border rounded-md flex justify-start items-center gap-4 pl-4 font-rubik">
    <img src="@/images/get-quote-modal/current-location.svg" alt="Fetch location">
    <p class="user-location-text">With this information, we can provide the ideal solution for you.</p>
  </div>
</template>

<script>
export default {
  mounted() {
    try {
      const ld = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        'headline': document.querySelector('.user-location-text')?.innerText || document.title,
        'description': document.querySelector('.user-location-text')?.innerText || '',
        'url': window.location.href,
        'publisher': {
          '@type': 'Organization',
          'name': 'Container Alliance',
          'url': window.location.origin
        }
      }
      const script = document.createElement('script')
      script.type = 'application/ld+json'
      script.text = JSON.stringify(ld)
      document.head.appendChild(script)
    } catch (e) {
      console.warn('Erro ao injetar JSON‑LD:', e)
    }
  }
}
</script>

<style scoped>
.user-location-text {
  font-size: 14px;
  font-weight: 400;
  line-height: 19.6px;
  letter-spacing: -0.02em;
  color: #FFFFFF;
} 
</style>